module.exports = __webpack_public_path__ + "media/images/title_mobile@2x-bd551f4e033537bb09b83e55ed3294ae.png";